(function () {
  'use strict';

  function normalizeText(value) {
    return String(value || '')
      .replace(/⅛/g, '1/8')
      .replace(/¼/g, '1/4')
      .replace(/½/g, '1/2')
      .replace(/¾/g, '3/4')
      .replace(/×/g, 'x')
      .replace(/[，,]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function hasInchUnit(value) {
    return /\b(in|inch|inches)\b|"/i.test(String(value || ''));
  }

  function normalizeMaterialAndHardnessTail(value) {
    var tail = normalizeText(value || '');
    tail = tail.replace(/\b(mm|millimeter|millimeters|in|inch|inches)\b/ig, '').replace(/"/g, '');
    tail = tail.replace(/\s+/g, ' ').trim();
    return tail;
  }

  function normalizeAs568Query(query) {
    var raw = normalizeText(query).toUpperCase();
    if (!raw) return '';

    raw = raw.replace(/\bDASH\b/g, '-');

    // AS568-236 / AS568 236 / AS 568 236 / AS-568-236 / AS568236 / AS568 dash 236
    var compact = raw.replace(/\s+/g, '').replace(/–|—/g, '-');

    var specific =
      compact.match(/\bAS[-]?568[-]?(\d{1,4})\b/) ||
      raw.match(/\bAS\s*[-]?\s*568\s*[-]?\s*(\d{1,4})\b/);

    if (specific) {
      var n = specific[1];
      if (n.length <= 3) n = n.padStart(3, '0');
      return 'AS568-' + n;
    }

    // Generic AS568 family search.
    if (/\bAS\s*[-]?\s*568\b/i.test(raw) || /\bAS568\b/i.test(compact)) {
      return 'AS568';
    }

    return '';
  }

  function normalizeOtherStandardQuery(query) {
    var raw = normalizeText(query);
    if (!raw) return '';

    // Keep these as fuzzy search terms, but normalize spacing so Shopify search is less random.
    var upper = raw.toUpperCase();

    var iso3601 = upper.match(/\bISO\s*[-]?\s*3601(?:\s*[-]?\s*1)?\b/);
    if (iso3601) return upper.replace(/\bISO\s*[-]?\s*3601\s*[-]?\s*1\b/g, 'ISO 3601-1').replace(/\bISO\s*[-]?\s*3601\b/g, 'ISO 3601');

    var din3771 = upper.match(/\bDIN\s*[-]?\s*3771\b/);
    if (din3771) return upper.replace(/\bDIN\s*[-]?\s*3771\b/g, 'DIN 3771');

    var bs1806 = upper.match(/\bBS\s*[-]?\s*1806\b/);
    if (bs1806) return upper.replace(/\bBS\s*[-]?\s*1806\b/g, 'BS 1806');

    var bs4518 = upper.match(/\bBS\s*[-]?\s*4518\b/);
    if (bs4518) return upper.replace(/\bBS\s*[-]?\s*4518\b/g, 'BS 4518');

    var jis = upper.match(/\bJIS\s*[-]?\s*B\s*[-]?\s*2401\b/);
    if (jis) return upper.replace(/\bJIS\s*[-]?\s*B\s*[-]?\s*2401\b/g, 'JIS B 2401');

    return '';
  }


  function parseNumberish(value) {
    var text = normalizeText(value || '');
    var frac = text.match(/^(\d+)\s*\/\s*(\d+)$/);
    if (frac) {
      var top = parseFloat(frac[1]);
      var bottom = parseFloat(frac[2]);
      return bottom ? top / bottom : NaN;
    }
    return parseFloat(text);
  }

  function looksLikeORingQuery(value) {
    return /\bo\s*[-]?\s*ring\b|\boring\b|\bseal\b|\bgasket\b/i.test(String(value || ''));
  }

  function normalizeLooseSizePairQuery(query) {
    var raw = normalizeText(query);
    if (!raw) return '';

    // Handles customer-style size input without an x: "3.15 1.8" or ".124 .071 o ring".
    var match = raw.match(/^(\d*\.?\d+|\d+\s*\/\s*\d+)\s+(\d*\.?\d+|\d+\s*\/\s*\d+)(.*)$/i);
    if (!match) return '';

    var id = parseNumberish(match[1]);
    var cs = parseNumberish(match[2]);
    if (!isFinite(id) || !isFinite(cs)) return '';

    var tail = match[3] || '';
    var inch = hasInchUnit(raw) || (looksLikeORingQuery(raw) && id > 0 && cs > 0 && id < 1 && cs < 1);
    if (inch) {
      id = id * 25.4;
      cs = cs * 25.4;
    }

    tail = normalizeMaterialAndHardnessTail(tail);
    tail = tail.replace(/\bo\s*[-]?\s*ring\b|\boring\b|\bseal\b|\bgasket\b/ig, '').replace(/\s+/g, ' ').trim();

    var normalized = id.toFixed(2) + ' x ' + cs.toFixed(2);
    return tail ? normalized + ' ' + tail : normalized;
  }

  function normalizeSingleInchHintQuery(query) {
    var raw = normalizeText(query);
    if (!raw || !looksLikeORingQuery(raw)) return '';

    // A single inch value is not enough for exact matching.
    // Route it to product-only search using the metric equivalent, then the search page guide asks users for ID × CS or AS568 for precision.
    var frac = raw.match(/(\d+)\s*\/\s*(\d+)/);
    if (frac) {
      var bottom = parseFloat(frac[2]);
      if (!bottom) return '';
      var dec = parseFloat(frac[1]) / bottom;
      return (dec * 25.4).toFixed(2) + ' o-ring';
    }

    var inch = raw.match(/(?:^|\s)(0?\.\d+|\d+\.\d+)\s*(?:in|inch|inches|")?(?:\s|$)/i);
    if (inch && (hasInchUnit(raw) || /^0?\./.test(inch[1]))) {
      return (parseFloat(inch[1]) * 25.4).toFixed(2) + ' o-ring';
    }

    return '';
  }

  function normalizeUseCaseQuery(query) {
    var raw = normalizeText(query).toLowerCase();
    if (!raw) return '';

    // Product-first intent mapping for common non-technical customer searches.
    // Keep the query narrow enough to produce product rows, while the search guide explains alternatives.
    if (/\b(viton|fpm)\b/.test(raw)) return 'FKM o-ring';
    if (/\b(ffkm|kalrez|perfluoro)\b/.test(raw)) return 'FFKM o-ring';
    if (/\b(food\s*grade|food-safe|foodsafe)\b/.test(raw) && /\bsilicone\b/.test(raw)) return 'Silicone o-ring';
    if (/\b(fuel|gasoline|petrol|diesel|chemical\s*resistant|solvent)\b/.test(raw)) return 'FKM o-ring';
    if (/\b(oil|grease)\b/.test(raw)) return 'NBR o-ring';
    if (/\b(high\s*temp|high-temperature|heat\s*resistant|hot\s*water)\b/.test(raw)) return 'FKM o-ring';
    if (/\b(steam)\b/.test(raw)) return 'EPDM o-ring';
    if (/\b(waterproof|water\s*proof|weather|outdoor|water\s*seal)\b/.test(raw)) return 'EPDM o-ring';
    if (/\b(automotive|auto|car|motorcycle|engine)\b/.test(raw)) return 'FKM o-ring';
    if (/\b(hydraulic|pneumatic|cylinder|pump|valve)\b/.test(raw)) return 'NBR o-ring';

    // Material-only customer searches should stay product-first.
    if (/\b(nbr|nitrile)\b/.test(raw) && looksLikeORingQuery(raw)) return 'NBR o-ring';
    if (/\b(epdm)\b/.test(raw) && looksLikeORingQuery(raw)) return 'EPDM o-ring';
    if (/\b(silicone|silicon)\b/.test(raw) && looksLikeORingQuery(raw)) return 'Silicone o-ring';
    if (/\bfkm\b/.test(raw) && looksLikeORingQuery(raw)) return 'FKM o-ring';

    return '';
  }


  function normalizeSizeQuery(query) {
    var raw = normalizeText(query);
    if (!raw) return '';

    var match = raw.match(/(\d+(?:\.\d+)?)\s*(?:x|\*)\s*(\d+(?:\.\d+)?)(.*)$/i);
    if (!match) return '';

    var id = parseFloat(match[1]);
    var cs = parseFloat(match[2]);
    if (!isFinite(id) || !isFinite(cs)) return '';

    var inch = hasInchUnit(raw);
    if (inch) {
      id = id * 25.4;
      cs = cs * 25.4;
    }

    var tail = normalizeMaterialAndHardnessTail(match[3] || '');
    var normalized = id.toFixed(2) + ' x ' + cs.toFixed(2);
    return tail ? normalized + ' ' + tail : normalized;
  }

  function normalizeTopQuery(query) {
    return normalizeAs568Query(query) ||
      normalizeOtherStandardQuery(query) ||
      normalizeSizeQuery(query) ||
      normalizeLooseSizePairQuery(query) ||
      normalizeSingleInchHintQuery(query) ||
      normalizeUseCaseQuery(query) ||
      '';
  }

  function searchUrlFor(query) {
    var normalized = normalizeTopQuery(query);
    if (!normalized) return '';
    return '/search?q=' + encodeURIComponent(normalized) + '&type=product';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.querySelector) return;

    var action = form.getAttribute('action') || '';
    var role = form.getAttribute('role') || '';
    var input = form.querySelector('input[name="q"], input[type="search"], .search__input');
    if (!input) return;

    if (action.indexOf('/search') === -1 && role !== 'search') return;

    var target = searchUrlFor(input.value);
    if (!target) return;

    event.preventDefault();
    event.stopPropagation();
    window.location.href = target;
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;

    var input = event.target;
    if (!input || !input.matches) return;
    if (!input.matches('input[name="q"], input[type="search"], .search__input')) return;

    var form = input.form;
    var action = form ? (form.getAttribute('action') || '') : '';
    var role = form ? (form.getAttribute('role') || '') : '';
    if (action.indexOf('/search') === -1 && role !== 'search') return;

    var target = searchUrlFor(input.value);
    if (!target) return;

    event.preventDefault();
    event.stopPropagation();
    window.location.href = target;
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('button, a, .search__button, .predictive-search__search-for-button button') : null;
    if (!button) return;

    var form = button.closest ? button.closest('form') : null;
    var input = null;

    if (form) {
      input = form.querySelector('input[name="q"], input[type="search"], .search__input');
    }
    if (!input) {
      input = document.querySelector('input[name="q"]:focus, input[type="search"]:focus, .search__input:focus');
    }
    if (!input) return;

    var target = searchUrlFor(input.value);
    if (!target) return;

    event.preventDefault();
    event.stopPropagation();
    window.location.href = target;
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    if (window.location.pathname !== '/search') return;
    var url = new URL(window.location.href);
    var q = url.searchParams.get('q') || '';
    var normalized = normalizeTopQuery(q);
    if (!normalized) return;
    if (normalizeText(q).toLowerCase() === normalizeText(normalized).toLowerCase()) return;

    url.searchParams.set('q', normalized);
    url.searchParams.set('type', 'product');
    window.location.replace(url.toString());
  });
})();